export const getMouApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `${params?.asset_type}/${params?.asset_slug}/mou${queryString ? `?${queryString}` : ""}`;
};

export const deleteAttachment = (slug) => {
    return `mou/${slug}/attachments`
}

export const getMouDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/supplement`;
}

export const addMuiApi = (params, payload) => {
    return `${params?.asset_type}/${params?.asset_slug}/mou`;
}

export const editMouApi = (params) => {
    return `${params?.asset_type}/${params?.asset_slug}/mou/${params?.slug}`;
}


export const deleteMouApi = (params, payload) => {
    return `${params?.asset_type}/${params?.asset_slug}/mou`;
}

export const moufileUploadPostApi = (supplement_slug) => {
    return `/get-pre-signed-url/mou_list/${supplement_slug}`;
};

export const mouUpdateAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/mou_list/${attachments_slug}`
}